import { render, staticRenderFns } from "./DtBreadcrumb.vue?vue&type=template&id=5ec363ae&"
import script from "./DtBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./DtBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./DtBreadcrumb.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports